const menu = () => {
  const button = document.querySelector('.js-hamburger');

  if (button) {
    button.addEventListener('click', () => {
      const buttonTarget = document.querySelector('.js-hamburger-target');
      const search = document.querySelector('.js-search-container');

      button.classList.toggle('is-active');
      buttonTarget.classList.toggle('is-active');
      search.classList.add('u-hidden');
    });
  }

  const language = document.querySelector('.js-language-mobile');

  if (language) {
    language.addEventListener('click', event => {
      event.preventDefault();
      const lang = document.querySelector('html').getAttribute('lang');
      if (lang === 'pl') {
        window.location = '/en';
      } else {
        window.location = '/';
      }
    });
  }

  const submenuLinks = document.querySelectorAll('.js-submenu-link-mobile');

  if (submenuLinks) {
    submenuLinks.forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        link.classList.toggle('is-clicked');
      });
    });
  }

  const fixedMenu = () => {
    const header = document.querySelector('.js-header');
    const content = document.querySelector('main');
    const tabsNav = document.querySelector('.js-content-tabs-nav');
    if (header) {
      const doc = document.documentElement;
      let prevScroll = window.scrollY || doc.scrollTop;
      let curScroll = null;
      let direction = 0;
      let prevDirection = 0;

      const toggleHeader = () => {
        if (direction === 2 && curScroll > 200) {
          header.classList.remove('is-active');
          header.classList.add('is-deactive');
          prevDirection = direction;
          if (tabsNav) {
            tabsNav.style.top = null;
          }
        } else if (direction === 1 && prevScroll - 20 > curScroll) {
          header.classList.add('is-active');
          header.classList.remove('is-deactive');
          prevDirection = direction;
          if (tabsNav) {
            // setTimeout(() => {
            tabsNav.style.top = `${header.offsetHeight}px`;
            // }, 400);
          }
        }
      };

      const checkScroll = () => {
        curScroll = window.scrollY || doc.scrollTop;
        if (curScroll > 300) {
          header.classList.add('is-fixed');
          content.style.paddingTop = `${header.offsetHeight}px`;
        } else {
          header.classList.remove('is-fixed');
          header.classList.remove('is-active');
          header.classList.remove('is-deactive');
          content.style.paddingTop = '';
        }
        if (
          curScroll > prevScroll &&
          !document.querySelector('.js-hamburger-target.is-active')
        ) {
          direction = 2;
        } else if (curScroll < prevScroll) {
          direction = 1;
        }

        if (direction !== prevDirection) {
          toggleHeader();
        }

        prevScroll = curScroll;
      };

      window.addEventListener('scroll', checkScroll);
    }
  };

  fixedMenu();
};

export default menu;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/menu.js